export default "__VITE_ASSET__CbNXT5Ct__"